module.exports = __webpack_public_path__ + "static/media/raise-or-fold2.a5a41af1.png";